import { useContext, useEffect } from 'react';
import { usePrevious } from '../../hooks/usePrevious';
import { HSAnalyticsContext } from '../context/HSAnalyticsContext';

export default function HSPageViewTracker({
  overrideTrack = false,
  pathname,
}: {
  overrideTrack?: boolean;
  pathname: string;
}) {
  const prevPathname = usePrevious(pathname);

  const { initialPageLoad, setInitialPageLoad } =
    useContext(HSAnalyticsContext);

  useEffect(() => {
    if ((!initialPageLoad || overrideTrack) && pathname !== prevPathname) {
      const _hsq = ((window as any)._hsq = (window as any)._hsq || []);
      _hsq.push(['setPath', pathname]);
      _hsq.push(['trackPageView']);
    }
    setInitialPageLoad(false);
  }, [
    initialPageLoad,
    overrideTrack,
    pathname,
    prevPathname,
    setInitialPageLoad,
  ]);

  return null;
}
